const Tap = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M6 8.5C6 6.567 7.567 5 9.5 5C11.433 5 13 6.567 13 8.5C13 8.5538 12.9988 8.60732 12.9964 8.66053L13.9878 8.83415C13.9959 8.72382 14 8.61239 14 8.5C14 6.01472 11.9853 4 9.5 4C7.01472 4 5 6.01472 5 8.5C5 9.14816 5.13704 9.76432 5.38371 10.3211C5.69168 10.2407 6.00697 10.1976 6.3236 10.1883C6.35991 10.1872 6.39615 10.1866 6.43231 10.1864C6.15677 9.68619 6 9.1114 6 8.5ZM9.50008 6C8.67165 6 8.00008 6.67157 8.00008 7.5V11.7514C7.41585 11.5535 6.75697 11.4355 6.1338 11.5029C5.67599 11.5524 5.2185 11.7045 4.83277 12.0185C4.44348 12.3354 4.16238 12.7889 4.01493 13.3787C3.97994 13.5187 4.00712 13.667 4.08949 13.7854C4.17186 13.9039 4.30138 13.981 4.44479 13.9969C7.0367 14.2849 8.35942 15.6976 8.99752 16.7248C9.47714 17.4969 10.4079 18.1322 11.4333 17.9539L12.9502 17.6901C13.8288 17.5373 14.5594 16.9281 14.8677 16.0912L15.8514 13.4209C16.3904 11.9576 15.4728 10.3632 13.9367 10.0942L11.0001 9.57995V7.5C11.0001 6.67157 10.3285 6 9.50008 6Z"
      fill="currentColor"
    />
  </svg>
);

export default Tap;
